/**
 * DataAssetAdminPage (0183).
 *
 * Mount point for /foundation/admin/data-assets. Thin wrapper handing
 * the adapter to the shared AdminListView, as every other register does.
 */
import { AdminListView } from "./AdminListView";
import { dataAssetAdapter } from "./dataAssetAdapter";

export function DataAssetAdminPage() {
  return <AdminListView adapter={dataAssetAdapter} />;
}
